import { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

export const useLogoRect = (aspect = 706 / 167, maxW = 706, maxHDesktop = 167, maxHTablet = 120) => {
  const [rect, setRect] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const calc = () => {
      const W = window.innerWidth;
      const H = window.innerHeight;

      const shortSide = Math.min(W, H);
      const isTablet = shortSide <= 834;

      const hardMaxH = isTablet ? maxHTablet : maxHDesktop;

      const maxArea = 0.08 * W * H;
      const hArea = Math.sqrt(maxArea / aspect);
      const wArea = aspect * hArea;

      let width = Math.min(wArea, maxW);
      let height = width / aspect;

      if (height > hardMaxH) {
        height = hardMaxH;
        width = height * aspect;
      }

      setRect({ width: Math.floor(width), height: Math.floor(height) });
    };

    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, [aspect, maxW, maxHDesktop, maxHTablet]);

  return rect;
};
